import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button, Avatar, Menu, MenuItem, ListItemIcon } from '@mui/material';
import { Google as GoogleIcon, Logout, AccountCircle, WorkspacePremium as PremiumIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const LoginButton = ({ onNavAction }) => {
    const { login, logout, isAuthenticated, user, isPremium } = useAuth();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        if (onNavAction) onNavAction();
    };

    const handleLogout = () => {
        logout();
        handleClose();
    };

    const handleLogin = () => {
        login();
        if (onNavAction) onNavAction();
    };

    if (isAuthenticated) {
        return (
            <>
                <Button
                    onClick={handleClick}
                    startIcon={user.imageUrl ?
                        <Avatar
                            src={user.imageUrl}
                            sx={{ width: 24, height: 24 }}
                        /> :
                        <AccountCircle />
                    }
                    endIcon={isPremium && <PremiumIcon sx={{ color: 'gold' }} />}
                    sx={{
                        color: 'white',
                        '&:hover': {
                            background: 'rgba(255, 255, 255, 0.1)'
                        }
                    }}
                >
                    {user.name || user.email}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        sx: {
                            minWidth: 240,
                            maxWidth: 300,
                            boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'
                        }
                    }}
                >
                    <MenuItem 
                        component={Link} 
                        to="/profile" 
                        onClick={handleClose}
                    >
                        <ListItemIcon>
                            <AccountCircle fontSize="small" />
                        </ListItemIcon>
                        Profile
                    </MenuItem>

                    {!isPremium && (
                        <MenuItem 
                            component={Link} 
                            to="/subscription" 
                            onClick={handleClose}
                            sx={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-word'
                            }}
                        >
                            <ListItemIcon>
                                <PremiumIcon fontSize="small" />
                            </ListItemIcon>
                            Upgrade to Premium
                        </MenuItem>
                    )}

                    <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                    </MenuItem>
                </Menu>
            </>
        );
    }

    return (
        <Button
            variant="outlined"
            onClick={handleLogin}
            startIcon={<GoogleIcon />}
            sx={{
                color: 'white',
                borderColor: 'white',
                '&:hover': {
                    borderColor: 'white',
                    background: 'rgba(255, 255, 255, 0.1)'
                }
            }}
        >
            Sign in
        </Button>
    );
};

export default LoginButton;